export const prop = {
    PORTALE_URL: process.env.PORTALE_URL,
    MINISITO_EMERGENZE_URL: process.env.MINISITO_EMERGENZE_URL,
    MINISITO_RISCHI_URL: process.env.MINISITO_RISCHI_URL,
    MINISITO_VOLONTARIATO_URL: process.env.MINISITO_VOLONTARIATO_URL,
    MINISITO_DOCS_URL: process.env.MINISITO_DOCS_URL,
    MINISITO_DOMANDE_E_RISPOSTE_URL: process.env.MINISITO_DOMANDE_E_RISPOSTE_URL,
    MINISITO_FORMAZIONE_URL: process.env.MINISITO_FORMAZIONE_URL,
    MINISITO_MAPPE_URL: process.env.MINISITO_MAPPE_URL,
    MINISITO_EVENTI_URL: process.env.MINISITO_EVENTI_URL,
    MINISITO_RELAZIONI_INTERNAZIONALI_URL: process.env.MINISITO_RELAZIONI_INTERNAZIONALI_URL,
    MINISITO_CAPRISCHIO_21_27_URL: process.env.MINISITO_CAPRISCHIO_21_27_URL,
    MINISITO_SERVIZIO_NAZIONALE_URL: process.env.MINISITO_SERVIZIO_NAZIONALE_URL,
    MINISITO_ATTUAZIONE_MISURE_PNRR_URL: process.env.MINISITO_ATTUAZIONE_MISURE_PNRR_URL,
    MINISITO_IT_ALERT_URL: process.env.MINISITO_IT_ALERT_URL,
    MINISITO_IO_NON_RISCHIO_URL: process.env.MINISITO_IO_NON_RISCHIO_URL
}

export function getSlug(slug, portaleAttuale, portaleContenuto) {
    let path = "";
    if(portaleAttuale === portaleContenuto)
        path = slug;
    else if(portaleContenuto){
        const propsName = portaleContenuto.toUpperCase() === 'PORTALE'
            ? 'PORTALE_URL'
            : `MINISITO_${portaleContenuto.toUpperCase().replace(new RegExp("[\\s-]+", "g"), '_')}_URL`

        path = prop[propsName] + slug;
    }
    return path;
}

export function getAccordionAndTabLinks(linkList, language, portaleAttuale) {
    let result= [];
    if(Array.isArray(linkList) && linkList.length > 0 ){
        result = linkList.map(item => {
            return {
                title: item.field_titolo_esteso,
                slug: getSlug('/' + language + item.fields?.slug, portaleAttuale, item.relationships?.field_sottodominio?.name)
            }
        })
    }
    return result;
}

export function getCategoriaPrimariaEN(categoriaPrimaria) {
    if(categoriaPrimaria !== ""){
        switch(categoriaPrimaria){
            case "comunicato_stampa":
                return "press release";
            case "notizia":
                return "news";
            case "approfondimento":
                return "supplementary worksheet";
            case "pubblicazione":
                return "publication";
            case "corsi":
                return "courses";
            case "pagina":
                return "page";
            case "galleria_foto":
            case "galleria_flickr":
                return "photo";
            case "video":
                return "video";
            case "bando_di_gara":
                return "call for tender";
            case "mappa":
                return "map";
            case "timeline":
                return "timeline";
            case "normativa":
                return "regulation";
            case"sezione":
                return "section";
            default:
                return "";
        }
    }
    return "";
}
